/* Built In Imports */

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import GoogleMap from '@components/Embeds/GoogleMap';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */
import { useEOEContext } from '@store/EOEContext';

/**
 *
 * @param {Object} section
 * @returns
 */
const HowToReach = ({ section, region, lang, cityId }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const sectionContent = section?.sectionContent;
  const { city } = useEOEContext();
  // console.log('cityHowtoReach', cityId, 'sss', city);

  // useEffect(() => {
  //   // console.log('useEffectcityHowtoReach', city);
  // }, [city]);

  return (
    <Box py={{ base: '25px', md: '40px' }} height="100%" minH="540px">
      <SectionTitle
        titleObj={sectionContent[0]}
        color="#fff !important"
        maxW="360px"
        lineHeight="120%"
      />
      <MidContainer>
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          mb="30px"
          justifyContent={{ base: 'center', lg: 'space-between' }}
        >
          <Box
            maxW={{ base: '100%', lg: '360px' }}
            mr={{ base: '0', md: '70px' }}
            pt={{ base: '20px', lg: '1%' }}
            pb="30px"
            m={{ base: '0 16px', lg: '0' }}
            // className="event-text"
            color="#fff"
          >
            <StructuredTextParser
              str={render(section?.sectionContent[2]?.body)}
              color="#fff"
              mt="0"
              fontSize={{ base: '16px', md: '18px' }}
              lineHeight={{ base: '26px', md: '30px' }}
              fontFamily="FedraSansStd-book"
              fontWeight="400"
              className="SIAStText"
            />
            <StructuredTextParser
              str={render(section?.sectionContent[3]?.body)}
              color="#fff"
              mt="24px"
              fontSize={{ base: '16px', md: '18px' }}
              lineHeight={{ base: '26px', md: '30px' }}
              fontFamily="FedraSansStd-book"
              fontWeight="auto"
              className="SIAStText"
            />
            {/* {StructuredTextContent(section?.sectionContent[2]?.body)} */}
            {!isMobile && sectionContent[3] && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Image
                  src={sectionContent[3]?.image?.url}
                  alt={sectionContent[3]?.image?.alt}
                  title={sectionContent[3]?.image?.title}
                  margin="0 10px"
                />
                <Image
                  src={sectionContent[4]?.image?.url}
                  alt={sectionContent[4]?.image?.alt}
                  title={sectionContent[4]?.image?.title}
                  margin="0 10px"
                />
              </Box>
            )}
            <style global jsx>
              {`
                .SIAStText p a {
                  color: #fbad2e;
                  text-decoration: underline;
                }
              `}
            </style>
          </Box>
          <Box width={{ base: 'auto', lg: '510px' }}>
            <GoogleMap sectionContent={sectionContent[1]} ht="280px" />
          </Box>
          {isMobile && sectionContent[3] && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <Image
                src={sectionContent[3]?.image?.url}
                alt={sectionContent[3]?.image?.alt}
                title={sectionContent[3]?.image?.title}
                margin="0 10px"
              />
              <Image
                src={sectionContent[4]?.image?.url}
                alt={sectionContent[4]?.image?.alt}
                title={sectionContent[4]?.image?.title}
                margin="0 10px"
              />
            </Box>
          )}
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default HowToReach;
